/* eslint-disable react/jsx-pascal-case */
import React from "react";
import Header from "../../components/header/header";
import Body from "../../components/body";
import globe from "../../assets/globe.png"

const Homepage = () => {
  return (
    
    <div className="w-full lg:h-screen bg-gradient-to-br from-[#060409] to-[#361e42] h-[100vh] ">
      <div className="bg-contain bg-no-repeat bg-right h-full" style={{backgroundImage: `url(${globe})`}}>
        <Header />
        <Body />
      </div>
    </div>
  );
};

export default Homepage;
